import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: false,
  loadFailed: false,
}

const setAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: payload,
  })

const setLoading = (state) =>
  updateObject(state, {
    loading: true,
    loadFailed: false,
  })

const setLoadingFail = (state) =>
  updateObject(state, {
    loading: false,
    loadFailed: true,
  })

const setLoadingEnd = (state) =>
  updateObject(state, {
    loading: false,
    loadFailed: false,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/SET_ACCOUNTS_CONNECTED':
      return setAccounts(state, action)
    case 'USER/ACCOUNTS_CONNECTED_FETCH_START':
      return setLoading(state, action)
    case 'USER/DELETE_ACCOUNT_FETCH_START':
      return setLoading(state, action)
    case 'USER/ACCOUNTS_CONNECTED_FETCH_FAIL':
      return setLoadingFail(state, action)
    case 'USER/DELETE_ACCOUNT_FETCH_FAIL':
      return setLoadingFail(state, action)
    case 'USER/ACCOUNTS_CONNECTED_FETCH_END':
      return setLoadingEnd(state, action)
    case 'USER/DELETE_ACCOUNT_FETCH_END':
      return setLoadingEnd(state, action)
    default:
      return state
  }
}

export default reducer
